import { useEffect, useState } from 'react'

export function useWebShareSupported(): boolean {
  const [supported, setSupported] = useState(false)
  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }
    setSupported('share' in window.navigator)
  }, [setSupported])

  return supported
}
